import { call, takeLatest } from "redux-saga/effects";
import {
  ANALYTICAL_REPORT_DOWNLOAD,
  DASHBOARD_VIEW,
  GRAPH_CARD,
} from "../actions/types";
import {
  analyticalReportDownloadApi,
  dashboardApi,
  graphCardApi,
} from "../apis/dashboardApi";

export function* dashboardWorker(action) {
  try {
    const res = yield call(dashboardApi);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* analyticalReportDownloadWorker(action) {
  try {
    const res = yield call(analyticalReportDownloadApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* graphCardWorker(action) {
  try {
    const res = yield call(graphCardApi, action.params);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* dashboardWatcher() {
  yield takeLatest(DASHBOARD_VIEW, dashboardWorker);
}

export function* analyticalReportDownloadWatcher() {
  yield takeLatest(ANALYTICAL_REPORT_DOWNLOAD, analyticalReportDownloadWorker);
}

export function* graphCardWatcher() {
  yield takeLatest(GRAPH_CARD, graphCardWorker);
}
